/**
 * Created by Ning Jiang on 2/28/2020.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";

export class DeadwoodBonusReelController extends SpinReelController {

    constructor(reelId:number) {
        super(reelId);
    }

    public removeReplacedSymbol(replacedSymbol:StateReelSymbol):void {
        // Can't use super.removeSymbol because we don't want to add them to the delete pool.
        this._reelView.removeChild(replacedSymbol);
        this._reelPartCreator.deleteSymbol(replacedSymbol);
    }
}